<template>
    <service-level :type="1"></service-level>
</template>

<script>
    import ServiceLevel from '../service/level.vue'

    export default {
        name: 'personServiceLevel',
        components: {
            ServiceLevel
        },
        data() {
            return {
            }
        },
        mounted() {
            
        },
        methods: {
        }
    }
</script>
